import { useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

const useAutoLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now();
      const expiryTime = decoded.exp * 1000;
      const timeUntilExpiry = expiryTime - currentTime;

      if (timeUntilExpiry > 0) {
        const timeout = setTimeout(() => {
          console.warn("Token expired. Logging out...");
          localStorage.clear();
          localStorage.setItem('logout', Date.now());
          navigate('/login');
        }, timeUntilExpiry);

        return () => clearTimeout(timeout); // Cleanup
      } else {
        localStorage.clear();
        navigate('/login');
      }
    } catch (err) {
      console.error("Invalid token:", err);
      localStorage.clear();
      navigate('/login');
    }
  }, [navigate]);
};

export default useAutoLogout;
